// extracted by mini-css-extract-plugin
export var boldText = "_7f-4";
export var checkboxContainer = "_7f-6";
export var closeIcon = "_7f-i";
export var container = "_7f-0";
export var drawer = "_7f-8";
export var drawerContent = "_7f-9";
export var extraSmallText = "_7f-5";
export var fulfillmentGroupTable = "_7f-e";
export var largeText = "_7f-3";
export var loadingSpinnerContainer = "_7f-j";
export var mediumText = "_7f-2";
export var narrow = "_7f-f";
export var notificationLink = "_7f-l";
export var packageCheckIconContainer = "_7f-7";
export var slideoutHeaderActions = "_7f-g";
export var slideoutHeaderActionsShifted = "_7f-h";
export var slideoutHeaderContainer = "_7f-a";
export var slideoutModal = "_7f-c";
export var stickyHeaderWrapper = "_7f-b";
export var table = "_7f-k";
export var tableContainer = "_7f-d";
export var tertiaryText = "_7f-1";